<ng-container>
  <app-header-mega-menu></app-header-mega-menu>
</ng-container>
<router-outlet></router-outlet>
<app-footer></app-footer>
